<div class="sk">
  <div class="sk__top">
    <h1 class="sk__title">{{ 'skillManagement.title' | translate }}</h1>
    @if (state === 'ready') {
      <span class="sk__summary">
        {{ 'skillManagement.summary' | translate: {skills: skills.length, categories: categories.length} }}
      </span>
    }
    <div class="sk__actions">
      <button type="button" class="tpl-btn" [disabled]="state !== 'ready'" (click)="openCategories()">
        <span class="sk__actions-icon"><app-skill-icon name="rows" [size]="18"/></span>
        {{ 'skillManagement.manageCategories' | translate }}
      </button>
      <button type="button" class="btn-primary" [disabled]="state !== 'ready'" (click)="openAdd()">
        <app-skill-icon name="plus" [size]="16"/>
        {{ 'skillManagement.add.open' | translate }}
      </button>
    </div>
  </div>

  @switch (state) {
    @case ('loading') {
      <div class="sk__state" role="status">{{ 'skillManagement.loading' | translate }}</div>
    }
    @case ('error') {
      <div class="sk__state sk__state--error" role="alert">
        {{ 'skillManagement.loadError' | translate }}
        <button type="button" class="tpl-btn" (click)="load()">{{ 'skillManagement.retry' | translate }}</button>
      </div>
    }
    @default {
      <div class="sk__cols">
        <app-skill-catalog [skills]="skills" [categories]="categories" [assignmentCounts]="assignmentCounts"
                           [selectedId]="selectedId" (selectSkill)="select($event)"/>
        @if (selectedSkill; as skill) {
          <app-skill-detail [skill]="skill" [allSkills]="skills" [categories]="categories"
                            [assignmentCount]="selectedAssignmentCount"
                            (saved)="onSkillSaved($event)" (merged)="onMerged($event)"
                            (deleteRequested)="openDelete($event)"/>
        } @else {
          <div class="sk-empty">{{ 'skillManagement.selectHint' | translate }}</div>
        }
      </div>
    }
  }
</div>

@if (categoriesOpen) {
  <app-skill-categories-modal [categories]="categories" (closed)="closeCategories()"
                              (saved)="onCategoriesSaved($event)"/>
}

@if (addOpen) {
  <app-skill-add-modal [skills]="skills" [categories]="categories"
                       [preselectCategory]="selectedSkill?.kategorie ?? null"
                       (closed)="closeAdd()" (created)="onSkillCreated($event)"/>
}

@if (deleteRequest; as request) {
  <app-skill-delete-modal [request]="request" [deleting]="deleting" (closed)="closeDelete()"
                          (confirmed)="confirmDelete()" (goToSimilar)="goToSimilar()"/>
}
